export const STYTCH_DEFAULT_SESSION_DURATION_MINUTES = 480;
export const EXTENDED_SESSION_DURATION_MINUTES = 90000;
export const OFFICE_ADDIN_INITIAL_SSO_SESSION_DURATION_MINUTES = STYTCH_DEFAULT_SESSION_DURATION_MINUTES;
export const OFFICE_ADDIN_EXTENDED_SESSION_DURATION_MINUTES = EXTENDED_SESSION_DURATION_MINUTES;
export const OFFICE_ADDIN_SESSION_JWT_REFRESH_INTERVAL_MS = 4 * 60 * 1000;
export function getSessionExpiresAt(durationMinutes) {
    return new Date(Date.now() + durationMinutes * 60 * 1000).toISOString();
}
export function getOfficeAddinExtendedSessionExpiresAt() {
    return getSessionExpiresAt(OFFICE_ADDIN_EXTENDED_SESSION_DURATION_MINUTES);
}
